import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1165ec80&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1165ec80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1165ec80')) {
      api.createRecord('1165ec80', component.options)
    } else {
      api.reload('1165ec80', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1165ec80&scoped=true&", function () {
      api.rerender('1165ec80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/origin/modules/table-list/index.vue"
export default component.exports